import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import AiAssistantEngine from './core/AiAssistantEngine';
import AiAssistantContext from './AiAssistantContext';
export const AiAssistantProvider = ({ children, apiKey, apiUrl, userId, scrapeContent, debug, }) => {
    const [aiAssistant, setAiAssistant] = useState();
    useEffect(() => {
        const aiAssistantInstance = new AiAssistantEngine(apiKey, apiUrl, userId, scrapeContent, debug);
        setAiAssistant(aiAssistantInstance);
    }, [apiKey, apiUrl, userId, scrapeContent, debug]);
    const contextValue = {
        aiAssistant,
        on: aiAssistant?.on.bind(aiAssistant),
        off: aiAssistant?.off.bind(aiAssistant),
        registerFunctions: aiAssistant?.registerFunctions.bind(aiAssistant),
    };
    return (_jsx(AiAssistantContext.Provider, { value: contextValue, children: children }));
};
export default AiAssistantProvider;
